import styled from 'src/style';
import { UppercaseWords, SentenceSmall } from 'src/components/Typography';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

export const UppercaseHeading = styled(UppercaseWords)({
  textAlign: 'center',
  marginBottom: 25,
  lineHeight: '40px',
  borderBottom: `1px solid ${colors.white}`,
});

export const LocationAndHours = styled(SentenceSmall)({
  color: colors.yellow,
  paddingBottom: 16,
  paddingTop: 8,
  lineHeight: '22px',
  letterSpacing: 0.6,
  [mediaQueries.desktopUp]: {
    paddingBottom: 24,
  },
});
